<form #form="ngForm" class="page-fix-accessibility-form">
    <page-fix-form-wizard-container (dismiss)="dismiss.emit()"
                                    (close)="closeModal($event.pageFix)"
                                    [formValid]="!!form.valid"
                                    [pageFixApplied]="!!pageFix"
                                    [pageFix]="pageFix">
        <page-fix-form-info-view [monType]="infoViewType"
                                 [monSelected]="!pageFix"
                                 [monOrder]="0">
            <img-slot>
                <img class="img-responsive image-sample inline-block"
                     src="/images/page-fix/website-structure/skip-to-content.png"
                     [attr.alt]="'Skip to Content' | translate"/>
            </img-slot>
            <txt-slot>
                <h2 translate>Why do I need a "skip to content" link?</h2>
                <p translate>
                    A "skip to content" link at the start of the webpage allows screen reader and keyboard-only users to skip over potentially non-relevant links at the start of your webpage and immediately access the main content.
                </p>
                <h3 translate>How are we going to fix it?</h3>
                <p translate>
                    Acquia Web Governance will add a link to the start of every page that allows the users to jump directly to the main content.
                    No worries, this link will only be discoverable when the visitor uses their keyboard to navigate.
                </p>
            </txt-slot>
        </page-fix-form-info-view>
        <page-fix-form-skip-to-content-options [monPageFix]="pageFix"
                                               [monPageFixId]="pageFixId"
                                               [monPageFixSelector]="pageFixSelector"
                                               [monType]="optionsViewType"
                                               [monSelected]="!!pageFix"
                                               [monOrder]="1">
        </page-fix-form-skip-to-content-options>
        <page-fix-form-info-view [monType]="testingViewType" [monOrder]="2">
            <img-slot>
                <img class="img-responsive image-sample inline-block"
                     src="/images/page-fix/website-structure/skip-to-content-test.png"
                     [attr.alt]="'Skip to Content' | translate"/>
            </img-slot>
            <txt-slot>
                <h2 translate>What to do when the link doesn't work?</h2>
                <p translate>
                    The two most likely problems have got to do with the CSS selectors you have chosen.
                    First, make sure that the CSS selectors are written without typos and in a format responding to the attribute type (class or id).
                    Second, your website might have different design and layout on its pages. Make sure you have included CSS selectors from all the pages.
                </p>
            </txt-slot>
        </page-fix-form-info-view>
    </page-fix-form-wizard-container>
</form>
